// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__L41n6","preview__wrapper":"Preview_preview__wrapper__MFgqF","preview__body":"Preview_preview__body__fvaAb"};